export function getApiResponseErrorMessage(err_obj, default_message = 'An error has occurred') {
	if (typeof err_obj === 'undefined') {
		return default_message
	}

	if (typeof err_obj === 'object' && err_obj?.response != null) {
		return err_obj.response.message ?? default_message;
	}

	return err_obj instanceof Error ? (err_obj.message ?? default_message) : (typeof err_obj === 'string' ? err_obj : default_message);
}
